import { 
	GetClassActionsTypes,
	GetStudentActionsTypes,
	CreateStudentActionsTypes, CreateStudentModel,
	UpdateStudentActionsTypes, UpdateStudentModel,
	DeleteStudentActionsTypes
} from './types';

export const getClassRequest  = (id: number) => (
	{
		type: GetClassActionsTypes.GET_CLASS,
		id: id
	}
);

export const getStudentRequest  = (id: number) => (
	{
		type: GetStudentActionsTypes.GET_STUDENT,
		id : id
	}
);

export const createStudentRequest  = (model: CreateStudentModel) => (
	{
		type: CreateStudentActionsTypes.POST_CREATE_STUDENT,
		model		
	}
);

export const updateStudentRequest  = (model: UpdateStudentModel) => (
	{
		type: UpdateStudentActionsTypes.PUT_UPDATE_STUDENT,
		model		
	}
);

export const deleteStudentRequest  = (id: number) => (
	{
		type: DeleteStudentActionsTypes.DELETE_STUDENT,
		id : id
	}
);
